import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { InvertButton, Popup, PrimaryButton } from 'component-library';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../contexts/AppContext';
import { Oem, OemIndirect } from '../../models/ApiModels';
import { GetOems, GetOemsIndirect, UpdateOemAsync } from '../../services/OemService';
import { ActionType } from '../../store/actionTypes';
import { LoadingSpinner } from '../../utils/LoadingSpinner';
import PermissionsGate, { ROLES } from '../../utils/PermissionGate';
import { FunctionPackagesPricesInfo } from '../IndirectCustomer/FunctionPackagesInfo';
import FunctionPackagesPrices from '../IndirectCustomer/FunctionPackagesPrices';

export const SettingsPrices = () => {
  const dispatch = useDispatch();
  const { currentOemTenantId, isHumphreeUser, currentOem } = useContext(AppContext);
  const oems = useSelector((state: any) => state.oems.data);
  const storeIndirectOem = oems.find((oem: any) => oem.id === currentOemTenantId);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const isBusinessUser = currentOem?.parentOEMTenantId === null;
  const [indirectOem, setIndirectOem] = useState<OemIndirect>(storeIndirectOem);
  const [openPopup, setOpenPopup] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setIndirectOem((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handlePriceChange = (index: number, newPrice: number) => {
    setIndirectOem((prev) => {
      const updatedPriceList = [...prev.settings.priceList];
      updatedPriceList[index] = { ...updatedPriceList[index], unitPrice: newPrice };
      return {
        ...prev,
        settings: {
          ...prev.settings,
          priceList: updatedPriceList,
        },
      };
    });
  };

  useEffect(() => {
    if (_.isEqual(indirectOem, storeIndirectOem)) setHasChanges(false);
    else {
      setHasChanges(true);
    }
  }, [indirectOem, storeIndirectOem]);

  function UpdateOem() {
    setLoading(true);
    if (indirectOem) {
      UpdateOemAsync(indirectOem as any)
        .then(() => {
          dispatch({
            type: ActionType.SET_SNACKBAR,
            payload: { heading: 'Successfully updated prices!', status: 'success' },
          });
          if (isHumphreeUser) {
            GetOems()
              .then((oems: Oem[]) => {
                dispatch({
                  type: ActionType.ADD_OEMS,
                  payload: oems,
                });
              })
              .catch((e: any) => {
                console.log(e);
              });
          } else {
            GetOemsIndirect(currentOem?.id as string)
              .then((res: any) => {
                dispatch({
                  type: ActionType.ADD_OEMS,
                  payload: res,
                });
              })
              .catch((e) => {
                console.log(e);
              });
          }
        })
        .finally(() => {
          setEditMode(false);
          setLoading(false);
        });
    }
  }
  function DiscardChanges() {
    setIndirectOem(storeIndirectOem);
    setOpenPopup(false);
    setEditMode(false);
  }

  return (
    <>
      {loading && <LoadingSpinner />}
      {!loading && (
        <div>
          <PermissionsGate roles={[ROLES.admin, ROLES.editor, ROLES.oemAdmin, ROLES.oemEditor]} rejected={undefined}>
            {(isBusinessUser || isHumphreeUser) && (
              <>
                <div className='w-full lg:ml-auto lg:w-fit flex flex-col gap-2 flex-wrap md:flex-nowrap md:flex-row lg:sticky top-0 right-0 z-10 my-6 lg:mt-11 lg:-mb-11 xl:mb-12 xl:-mt-12'>
                  {!editMode ? (
                    <PrimaryButton icon={faPenToSquare} label={'Edit prices'} onClick={() => setEditMode(!editMode)} />
                  ) : (
                    <div className='flex gap-2 w-full'>
                      <InvertButton
                        label={'Leave edit'}
                        onClick={() => (!hasChanges ? setEditMode(!editMode) : setOpenPopup(true))}
                      />
                      <PrimaryButton label={'Save prices'} onClick={() => UpdateOem()} disabled={!hasChanges} />
                    </div>
                  )}
                </div>
              </>
            )}
          </PermissionsGate>
          <FunctionPackagesPricesInfo />
          <FunctionPackagesPrices
            indirectOem={indirectOem}
            handlePriceChange={handlePriceChange}
            handleChange={handleChange}
            editMode={editMode}
          />
        </div>
      )}
      {openPopup && (
        <Popup
          close={() => setOpenPopup(false)}
          confirm={DiscardChanges}
          heading='Discard price changes?'
          paragraph='You will lose all the changes made to the prices.'
          status='error'
          cancelText='Keep editing'
          confirmText='Discard changes'
        />
      )}
    </>
  );
};
